import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import Testimonial from "./../components/testimonial";
import SectionContent from "./../scripts/sectionContent";

const Testimonails = () => {

    const data = useStaticQuery(graphql`
        query testimonialSectionQuery {
            allContentfulSectionContent(filter: {section: {eq: "Testimonials"}, page: {eq: "Homepage"}}) {
                edges {
                    node {
                        id
                        content {
                            childMarkdownRemark {
                                html
                                rawMarkdownBody
                            }
                        }
                        contentType
                    }
                }
            }
            allContentfulTestimonials(sort: {fields: id, order: ASC}) {
                edges {
                    node {
                        id
                        name
                        company
                        comment
                        image {
                            fluid(quality: 100) {
                                src
                            }
                        }
                    }
                }
            }
        }
    `);

    const sectionContent = new SectionContent(data.allContentfulSectionContent);

    return (
        <section id="testimonials" className="testimonials section bg-gradient-gray">
            <div className="container mx-auto">
                <div className="flex text-center">
                    <div className="col w-full md:w-1/2 mx-auto">
                    <h3 className="section__heading text-2xl mx-auto mb-24">{ sectionContent.getContent('heading').rawMarkdownBody }</h3>
                        <div className="testimonials__slider">
                            <div className="glider">
                                {
                                    data.allContentfulTestimonials.edges.map(edge => (
                                        <Testimonial testimonial={edge.node} key={ edge.node.id }/>
                                    ))
                                }
                                
                            </div>
                            <div className="glider__dots"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonails;